var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 286,
    viewBox: "0 0 289 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 0L170.998 19.8361L203.273 12.4927L219.413 41.3916L251.884 47.8106L254.874 80.7755L281.928 99.847L271.251 131.178L288.208 159.604L265.711 183.884L269.641 216.75L239.213 229.78L229.435 261.403L196.338 260.93L174.543 285.842L144.5 271.949L114.457 285.842L92.6618 260.93L59.565 261.403L49.7869 229.78L19.3593 216.75L23.2888 183.884L0.79158 159.604L17.7492 131.178L7.07233 99.847L34.1259 80.7755L37.1156 47.8106L69.5874 41.3916L85.7266 12.4927L118.002 19.8361L144.5 0Z",
    fill: "#FFB299"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigStar);
export default __webpack_public_path__ + "static/media/big-star.64ff9ecc8a82fbaf113a0a209fd6b6a6.svg";
export { ForwardRef as ReactComponent };